
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateReservationDtoFormGroup() {
return new FormGroup({
    businessunitId: new FormControl<number | undefined>(undefined),
    reservationteamId: new FormControl<number | undefined>(undefined),
    reservationtypeIds: new FormControl<Array<number> | undefined>([]),
    start: new FormControl<string | undefined>(undefined),
    end: new FormControl<string | undefined>(undefined),
    titleId: new FormControl<number | undefined>(undefined),
    company: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    street: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    zipcode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    city: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    canton: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    objectStreet: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    objectZip: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    objectCity: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    objectCanton: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    notes: new FormControl<string | undefined>(''),
    email: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    utm: new FormControl<string | undefined>(''),
    referralCode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    accessKey: new FormControl<string | undefined>('', [Validators.required]),
    processedAt: new FormControl<string | undefined>(undefined),
})
;
}
      